import { Controller } from "../Controller.js";
import type { PlayerState } from "../../../../royalur/model/PlayerState.js";
import type { PlayerStateDirective } from "./PlayerStateDirective.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import { BasicPlayerStateDirective } from "./BasicPlayerStateDirective.js";
import { ReplayPlayerStatesDirective } from "./ReplayPlayerStatesDirective.js";


export interface ReplayPlayerState {
    moveIndex: number;
    lightPlayerState: PlayerState;
    darkPlayerState: PlayerState;
    activePlayer: PlayerType;
}


/**
 * Controls the rendering directives to give to the dice.
 */
export class PlayerStateController extends Controller<PlayerStateDirective> {
    override setup(): () => void {
        return () => {};
    }

    override onDiscardedDirectives(_directives: PlayerStateDirective[]): void {
        // Nothing to do.
    }

    createBasic(
        moveIndex: number,
        lightPlayerState: PlayerState,
        darkPlayerState: PlayerState,
        activePlayer: PlayerType,
    ): PlayerStateDirective[] {

        return [new BasicPlayerStateDirective(
            this.assignNextDirectiveID(),
            moveIndex,
            lightPlayerState,
            darkPlayerState,
            activePlayer,
        )];
    }

    createReplay(
        states: ReplayPlayerState[],
    ): PlayerStateDirective[] {
        if (states.length <= 0)
            throw new Error("Requires at least one state");

        const stateDirectives: PlayerStateDirective[] = [];
        for (let index = 0; index < states.length; ++index) {
            const {
                moveIndex,
                lightPlayerState,
                darkPlayerState,
                activePlayer,
            } = states[index];

            stateDirectives.push(new BasicPlayerStateDirective(
                this.assignNextDirectiveID(),
                moveIndex,
                lightPlayerState,
                darkPlayerState,
                activePlayer,
            ));
        }

        return [
            new ReplayPlayerStatesDirective(
                this.assignNextDirectiveID(),
                stateDirectives,
            ),
        ];
    }
}
